import { generateUUID } from "./uuid";

const normalizeAmount = (amount) => {
  if (amount === null || amount === undefined || amount === "") return "FULL";
  const value = Number(amount);
  return Number.isFinite(value) ? value.toFixed(2) : "FULL";
};

export const buildPaymentSignature = ({ scope, method, amount }) =>
  `${scope || "UNKNOWN"}::${String(method || "").toUpperCase()}::${normalizeAmount(amount)}`;

export const isRetryablePaymentError = (error) => {
  const status = error?.status;
  const numericStatus = Number(status);

  if (status === "FETCH_ERROR" || status === "TIMEOUT_ERROR") return true;
  if (numericStatus === 0 || numericStatus === 408 || numericStatus === 429) return true;
  if (numericStatus >= 500 && numericStatus <= 599) return true;

  return false;
};

export const nextIdempotencyState = (prev, signature) => {
  if (
    prev?.retryAllowed &&
    prev?.signature === signature &&
    typeof prev?.key === "string" &&
    prev.key
  ) {
    return { ...prev, signature };
  }

  return {
    signature,
    key: generateUUID(),
    retryAllowed: false,
  };
};
